import React from "react";
import Landing from "../src/pages/Landing";
import "./css/style.css";

function App() {
  return (
    <div className="App">
      <Landing />
    </div>
  );
}

export default App;
